export default __webpack_public_path__ + "static/media/logo.de9ca5fd.png";